import {HandlerList} from "../../../../../infrastructure/handlers/handler-list";
import {EntityClickEventHandler} from "../../../../../core/handlers/entity-click-event.handler";
import {StandingsClickEventHandler} from "../../../../../core/handlers/standings-click-event.handler";
import {MegaHeaderFetchHandler} from "./mega-header.fetch-handler";
import {PopulateDataHandler} from "../../../../../infrastructure/handlers/populate-data-handler";
import {BracketsClickEventHandler} from "../../../../../core/handlers/brackets.click-event.handler";
import {TimingHandler} from "../../../../../infrastructure/handlers/timing-handler";
import {TopStatsClickEventHandler} from "../../../../../core/handlers/top-stats-click-event.handler";
import {SquadClickEventHandler} from "../../../../../core/handlers/squad-click-event.handler";

export class MegaHeaderModuleHandlers extends HandlerList {

  static injectables = [
    StandingsClickEventHandler,
    BracketsClickEventHandler,
    TopStatsClickEventHandler,
    SquadClickEventHandler,
    EntityClickEventHandler,
    MegaHeaderFetchHandler,
    PopulateDataHandler,
    TimingHandler
  ];

  constructor(
    standingsClickEventHandler: StandingsClickEventHandler,
    bracketsClickEventHandler: BracketsClickEventHandler,
    topStatsClickEventHandler: TopStatsClickEventHandler,
    squadClickEventHandler: SquadClickEventHandler,
    entityClickEventHandler: EntityClickEventHandler,
    megaHeaderFetchHandler: MegaHeaderFetchHandler,
    populateDataHandler: PopulateDataHandler,
    timingHandler: TimingHandler
  ) {
    super();
    [
      standingsClickEventHandler,
      bracketsClickEventHandler,
      topStatsClickEventHandler,
      squadClickEventHandler,
      entityClickEventHandler,
      megaHeaderFetchHandler,
      populateDataHandler,
      timingHandler
    ].forEach(handler => this.add(handler));
  }
}
